import { featureAtom } from "@sunrise/feature-flags";

export const disableVideoAdsAtom = featureAtom("disable-video-ads", false, {
  description: `Feature flag to disable video ads.`,
});
